import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ShareButton from '../atoms/ShareButton';
import { Link } from 'react-router-dom';
import { getAvatarDetails } from '../utils';

const LearningSubtitle = styled.h6`
  margin-bottom: 0;
`;

const LearningTitle = styled.h1`
  margin-top: 0;
`;

const ButtonHolder = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-content: center;
  .text {
    width: inherit;
    font-size: 2rem;
    font-family: ${props => props.theme.typeface.serif};
    border-color: transparent;
    background-color: transparent;
    padding-left: 0;
    padding-right: 0;
    &:hover { 
      color: ${props => props.theme.colours.link};
      background-color: transparent; 
      text-decoration: underline;
    }
  }
  .skip {
    font-weight: normal;
    color: ${props => props.theme.colours.darkGrey};
    line-height: 4.5rem;
    text-decoration: none;
  }
`;

class LearningOutcomes extends Component {

  render() {
    const { currentAvatar } = this.props.avatar;

    return (
      <main>
        <LearningSubtitle className="subtitle">Learning Outcome {getAvatarDetails(currentAvatar).id}</LearningSubtitle>
        { currentAvatar === 'm' &&
        <>
          <LearningTitle>Diversity of labels</LearningTitle>

          <p>The automatic avatar generation for VR needs to be able to serve different and diverse users. For that, we need to <strong>have a diverse set of people building this technology</strong>. Technology starts with the people behind it. </p>

          <p>As we will see throughout this exercise, diversity of people is key to ensuring diversity of images and diversity of labels, which are important components to reduce the possibility of bias in machine learning.</p>
        </> }

        { currentAvatar === 'f' &&
        <>
          <LearningTitle>Diversity of images</LearningTitle>

          <p>You may have noticed that this example used a photo of someone from a different background. This required us to give you different labels.</p>

          <p>It’s important when training machine learning to <strong>use a diverse set of photos</strong>. This helps mitigate potential bias.</p>
        </> }

        { currentAvatar === 'om' &&
        <>
          <LearningTitle>Diversity of labels</LearningTitle>

          <p>When creating this last avatar, you may have noticed that there were a lack of labels available to describe that person’s complexion.</p>

          <p>This is one of the challenges of machine learning labeling: <strong>ensure you have all the labels needed to annotate a diverse dataset</strong>.</p>

          <p>Having a diverse set of labels is important when training machine learning and leads to a reduction of bias.</p>
        </> }

        <ButtonHolder>
          <ShareButton/>
          <Link className="skip text" to="/your-avatar">Back</Link>
        </ButtonHolder>
      </main>
    )
  }
}

function mapStateToProps( state ) {
  return {
    avatar: state.avatar,
  };
}

export default connect( mapStateToProps )( LearningOutcomes );
